import React from 'react';
import PropTypes from 'prop-types';
import locations from '../../../containers/GuestPortal/Screens/BackgroundCheck/components/locations';
import getFlag from '../../../libs/emojyFlag';
import {findInTrie, getCountriesTrie} from './utils';
import {
    FormControl,
    FormHelperText,
    Input,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Popper,
} from '@material-ui/core';
import Autocomplete, {createFilterOptions} from '@material-ui/lab/Autocomplete';

const countriesTrie = getCountriesTrie(locations.countries);

let PhoneNumber = ({variant, fullWidth, label, placeholder, input, meta: {touched, invalid, error}, ...custom}) => {
    const getCountryByCountryCode = (code, countries) => {
        const index = countries.findIndex((country) => country.code === code);
        return countries[index];
    };
    const guessSelectedCountry = (inputNumber) => {
        return findInTrie(countriesTrie, inputNumber);
    };
    const countryAutoCompleteFilterOptions = createFilterOptions({
        stringify: ({name, dialCode, code}) => `${name} ${code} ${dialCode}`
    });

    const helperTextId = custom.helperText && custom.id ? `${custom.id}-helper-text` : undefined;
    const inputLabel = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    const [warning, setWarning] = React.useState(null);
    const [state, setState] = React.useState({
        selectedCountry: getCountryByCountryCode('US', locations.countries),
        phoneNumber: '',
    });

    React.useEffect(() => {
        if (label) {
            setLabelWidth(inputLabel.current.offsetWidth);
        }
        if (input && typeof input.value === 'string') {
            const inputPhoneNumber = input.value.startsWith('+') ? input.value : '+'.concat(input.value);
            setState({
                ...state,
                selectedCountry: guessSelectedCountry(inputPhoneNumber),
                phoneNumber: inputPhoneNumber
            });
        }
    }, []);

    React.useEffect(() => {
        if (custom.onCountryCodeSelect && state.selectedCountry && state.selectedCountry.code) {
            custom.onCountryCodeSelect(state.selectedCountry.code);
        }
    }, [state.selectedCountry]);

    const handlePhoneNumberChange = event => {
        const inputNumber = event.target.value;
        if (inputNumber.length <= 1) {
            setState({...state, phoneNumber: '+'});
        } else {
            const guessedCountry = guessSelectedCountry(inputNumber);
            if (guessedCountry === undefined) {
                setWarning('Make sure you select your correct country code');
            }
            if (guessedCountry && warning !== null) {
                setWarning(null);
            }
            if (state.selectedCountry === guessedCountry) {
                setState({...state, phoneNumber: inputNumber});
            } else {
                setState({...state, selectedCountry: guessedCountry, phoneNumber: inputNumber});
            }
        }

        // input.onChange comes from redux.form
        if (input && input.onChange) {
            input.onChange(`${state.phoneNumber}`);
        }
    };

    const handleSelectedCountryChange = (event, country) => {
        if (country) {
            setState({...state, selectedCountry: country, phoneNumber: country.dialCode});
            if (typeof document !== 'undefined') {
                document.getElementById('input-phone').focus();
            }
        }
    };

    const PopperWrapper = props => (
        <Popper {...props} style={{width: anchorEl ? anchorEl.clientWidth : null}} anchorEl={anchorEl}/>
    );
    const InputElement = variant && variant === 'outlined' ? OutlinedInput : Input;
    const inputElementProps = {
        id: custom.id || `input-${input.name}`,
        name: input.name,
    };
    if (variant && variant === 'outlined') {
        inputElementProps.fullWidth = fullWidth;
    }
    if (label) {
        inputElementProps.labelWidth = labelWidth;
    }

    return (
        <FormControl
            fullWidth={fullWidth}
            variant={variant}
            error={(invalid || Boolean(error) || Boolean(warning))}
        >
            {label &&
            <InputLabel
                ref={inputLabel}
                htmlFor={`select-${input.name}`}
            >
                {label}
            </InputLabel>
            }
            <InputElement
                type="text"
                placeholder={placeholder}
                ref={setAnchorEl}
                {...inputElementProps}
                {...input}
                value={state.phoneNumber || (state.selectedCountry && state.selectedCountry.dialCode)}
                onChange={handlePhoneNumberChange}
                startAdornment={
                    <InputAdornment
                        position="start"
                    >
                        <Autocomplete
                            id="country-select"
                            options={locations.countries}
                            disableClearable
                            value={state.selectedCountry}
                            onChange={handleSelectedCountryChange}
                            autoHighlight
                            filterOptions={countryAutoCompleteFilterOptions}
                            PopperComponent={PopperWrapper}
                            getOptionLabel={(option) => `${getFlag(option.code)}`}
                            renderOption={(option) => `${getFlag(option.code)} ${option.name} (${option.dialCode})`}
                            renderInput={(params) => (
                                <Input
                                    disableUnderline
                                    type="text"
                                    {...params.InputProps}
                                    inputProps={params.inputProps}
                                />
                            )}
                            {...custom.AutocompleteProps}
                        />
                    </InputAdornment>
                }
            />
            {((invalid && error) || warning || custom.helperText) && (
                <FormHelperText id={helperTextId} error={Boolean(warning) || Boolean(error)} {...custom.FormHelperTextProps}>
                    {(invalid && error) || warning || custom.helperText}
                </FormHelperText>
            )}
        </FormControl>
    );
};

PhoneNumber.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
};

export {PhoneNumber};
export default PhoneNumber;